<template>
    <div>
        <router-link v-if="$can('manage','pos')"
                     :to="'pos/request-details/'+row.id"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.details') }}</span>
                <i class="fa fa-eye"></i>
            </div>
        </router-link>
        <router-link v-else
                     :to="'pos/edit/'+row.id"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.details') }}</span>
                <i class="fa fa-eye"></i>
            </div>
        </router-link>
        <div v-if="row.status == posStatuses.ACTIVE && !$can('manage','pos')"
             class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
             @click="disablingTerminal">
            <span class="tooltip-text">{{ $t('pos.disable_terminal') }}</span>
            <i class="fa fa-trash"></i>
        </div>
        <div
             class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
             @click="deleteTerminal">
            <span class="tooltip-text">{{ $t('label.delete') }}</span>
            <i class="fa fa-trash"></i>
        </div>
         <div v-if="row.status == posStatuses.AGENCY_DISABLE_CHECK && $can('manage','pos')"
             class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
             @click="disablingTerminal">
            <span class="tooltip-text">{{ $t('pos.send_disable_terminal') }}</span>
            <i class="fa fa-trash"></i>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import toastr from 'toastr'
import {posStatuses} from "@/constants/PosStatus";
import {posService} from '@/common/api.service'
import {i18n} from '@/plugins/i18n';

export default Vue.extend({
    data() {
        return {
            posStatuses
        }
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        disablingTerminal() {
            var result = confirm(i18n.t('pos.message.disable_terminal_alert'));
            if (!result) return;

            posService.disableTerminal(this.row.id).then(response => {
                if (this.$can('manage', 'pos')) {
                    this.row.status = posStatuses.DISABLE
                } else this.row.status = posStatuses.AGENCY_DISABLE_CHECK

                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            });
        } ,
        deleteTerminal() {
            var result = confirm(i18n.t('pos.message.delete_terminal_alert'));
            if (!result) return;

            posService.deleteTerminal(this.row.id).then(response => {
                this.datatable.reload()
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            });
        }
    }
})
</script>